module.exports = __webpack_public_path__ + "static/media/Meme Merchant v0.1.4c0c2bf1.pdf";